"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccessoriesCart_1 = require("./AccessoriesCart");
exports.default = AccessoriesCart_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/AccessoriesCart/index.js
// module id = 786
// module chunks = 8